import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
} from '@twistopayments/design-system/styles'

export const image = (theme: Theme) => css`
  width: 100%;
  height: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.lg};

  ${breakpoint.up('smMd')} {
    min-height: 0;
    max-height: 240px;
    border-radius: ${theme.borderRadius.md};
  }
`

export const featuredImage = (theme: Theme) => css`
  ${breakpoint.up('smMd')} {
    max-height: unset;
    border-radius: ${theme.borderRadius.lg};
  }
`

export const badge = (theme: Theme) => css`
  padding: ${size[8]};
  background-color: ${theme.palette.secondary.mainContrast};
  border-radius: ${theme.borderRadius.lg};
  color: ${theme.palette.background.main};
  font-size: ${pxToRem(12)};
  font-weight: 500;
`

export const featuredBadge = (theme: Theme) => css`
  padding: ${size[8]} ${size[12]};
  border-radius: ${theme.borderRadius.xl};
  font-size: ${fontSize.smMd};
  font-weight: 700;
`

export const featured = css`
  height: 360px;
  margin-bottom: 48px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${size[80]};
  align-items: center;
  cursor: pointer;
`

export const featuredDetails = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
`

export const featuredDate = css`
  display: flex;
  gap: ${size[24]};
`

export const date = css`
  display: flex;
  align-items: center;
  gap: ${size[12]};
  font-size: ${pxToRem(16)};
`

export const featuredName = css`
  margin: 0;
  font-size: ${fontSize.xxl};
  font-weight: 600;
`
